export type Basic = string | number | boolean | null | undefined;

export const BASIC_ROW_HEIGHT = 30;

export const isValueStringEmpty = (value: Basic): boolean => {
  if (typeof value === 'number' || typeof value === 'boolean') {
    return false;
  }
  return !value;
};

export const getTooltipTitle = ({ value1, value2 }: { value1?: number | string; value2?: number }) => {
  if ((value1 || value1 === 0) && (value2 || value2 === 0)) {
    return `${value1}/${value2}`;
  } else if (value1 || value1 === 0) {
    return `${value1}`;
  } else {
    return '';
  }
};
